import { lazy } from 'react';
import type { RouteObject } from 'react-router';

import { MainLayout } from '@/layout';

import SearchParamsGuard from './SearchParamsGuard';

const routes: RouteObject[] = [
  {
    path: 'modeling',
    Component: MainLayout,
    children: [
      {
        path: '',
        Component: () => (
          <SearchParamsGuard
            configs={[
              {
                prefix: 'modeling',
                limit: 10,
                offset: 0,
              },
            ]}
          />
        ),
        children: [
          {
            path: '',
            Component: lazy(() => import('@/page/modeling/ModelingPage')),
          },
        ],
      },
      {
        path: ':modelingId/training',
        Component: lazy(
          () => import('@/page/modeling/ModelVersionTrainingPage'),
        ),
      },
      {
        path: ':modelingId',
        Component: () => {
          return (
            <SearchParamsGuard
              configs={[
                {
                  prefix: 'modeling',
                  limit: 10,
                  offset: 0,
                },
              ]}
            />
          );
        },
        children: [
          {
            path: '',
            Component: lazy(() => import('@/page/modeling/ModelingDetailPage')),
          },
        ],
      },
      {
        path: 'training',
        Component: lazy(() => import('@/page/modeling/ModelTrainingPage')),
      },
      {
        path: ':modelingId/:versionId',
        Component: lazy(
          () => import('@/page/modeling/VersionModelingDetailPage'),
        ),
      },
    ],
  },
];

export default routes;
